.list {
  list-style: none;
  margin: 0;
  padding: var(--space-3) 0;
}

.row {
  display: grid;
  grid-template-columns: minmax(140px, 220px) minmax(0, 1fr) 84px;
  align-items: center;
  gap: var(--space-4);
  height: 40px;
  padding: 0 var(--space-5);
}

.row[data-highlight] {
  background: color-mix(in srgb, var(--accent-secondary) 8%, transparent);
}

.label {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  min-width: 0;
  font-size: var(--text-sm);
  color: var(--text-secondary);
  text-decoration: none;
}

a.label:hover .name {
  color: var(--text-primary);
  text-decoration: underline;
  text-underline-offset: 3px;
}

.row[data-highlight] .label {
  color: var(--text-primary);
  font-weight: var(--weight-semi);
}

.rank {
  width: 24px;
  flex-shrink: 0;
  font-variant-numeric: tabular-nums;
  color: var(--text-muted);
}

.name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.value {
  text-align: right;
  font-size: var(--text-sm);
  font-weight: var(--weight-semi);
  font-variant-numeric: tabular-nums;
  color: var(--text-primary);
}

@media (max-width: 640px) {
  .row {
    grid-template-columns: 120px minmax(0, 1fr) 64px;
    gap: var(--space-2);
    padding: 0 var(--space-3);
  }
}
